import { styled } from '@mui/system';
import FormRow from 'Components/FormRow';
import InputHandler from 'Components/InputHandler';
import { withFormContext } from 'Containers/FormContextHandler';
import { nmosdDiagnosticCriteria } from 'neuro-schemas';
import * as React from 'react';
import { filterDocumentsByType } from 'Utility/documentHandling';
import colors from '../../../../../../../config/theme/colors';
import { ReferenceText } from '../../../../../utils/styled';
import AQP4 from './AQP4-IgG';
import NMOSDCoreClinicalCharacteristics from './CoreClinicalChar';
import NeuroImaging from './Neuroimaging';
import NMOSDWithAQP4 from './NMOSDWithAQP4';
import NMOSDWithoutAQP4 from './NMOSDWithoutAQP4';
import RedFlags from './RedFlags';

import type { IFormContext } from 'Containers/FormContextHandler';

const {
  utils: { showNOMSDWithAQP4, showNOMSDWithoutAQP4 },
} = nmosdDiagnosticCriteria;

const Header = styled('div')({
  fontWeight: 600,
  fontSize: '2rem',
  color: colors.primaryText,
  margin: '0rem 0 2rem 0',
});

const DEFAULT_DOCUMENTS: IDocumentV2[] = [];
const NMOSDDiagnosticCriteria = ({
  documents = DEFAULT_DOCUMENTS,
  formData,
  view,
  editing,
  fm,
}: IFormContext<IDocumentWithTypeV2<'nmosdDiagnosticCriteria'>>): React.JSX.Element => {
  const [showNMOSDResultsWithAQP4, setNMOSDResultsWithAQP4] = React.useState<boolean>(false);
  const [showNMOSDResultsWithoutAQP4, setNMOSDResultsWithoutAQP4] = React.useState<boolean>(true);

  const docs = filterDocumentsByType(documents, ['nmosdDiagnosticCriteria']);

  React.useEffect(() => {
    setNMOSDResultsWithAQP4(showNOMSDWithAQP4(formData.document));
    setNMOSDResultsWithoutAQP4(showNOMSDWithoutAQP4(formData.document));
  }, [formData.document]);

  return (
    <React.Fragment>
      <React.Fragment>
        <Header>{fm('diagnosis.nmosdDiagnosticCriteria.header')}</Header>
        <FormRow title="general.date">
          <InputHandler
            type="PartialDate"
            editing={!!editing}
            name="date"
            formData={formData}
            dateDefault="now"
            isNotCancellable={true}
          />
        </FormRow>
        <NMOSDCoreClinicalCharacteristics documents={docs} formData={formData} view={view} editingID={editing} />
        <NeuroImaging documents={docs} formData={formData} view={view} editingID={editing} />
        <RedFlags documents={docs} formData={formData} view={view} editingID={editing} />
        <AQP4 documents={docs} formData={formData} view={view} editingID={editing} />
        {showNMOSDResultsWithAQP4 ? (
          <NMOSDWithAQP4 documents={docs} formData={formData} view={view} editingID={editing} />
        ) : null}
        {showNMOSDResultsWithoutAQP4 ? (
          <NMOSDWithoutAQP4 documents={docs} formData={formData} view={view} editingID={editing} />
        ) : null}
        <ReferenceText>
          Wingerchuk DM, Banwell B, Bennett JL et al. International consensus diagnostic criteria for neuromyelitis
          optica spectrum disorders. Neurology. 2015.
        </ReferenceText>
      </React.Fragment>
    </React.Fragment>
  );
};

export default withFormContext(NMOSDDiagnosticCriteria);
